import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js'

@Component({
  selector: 'app-lib-login-default',
  templateUrl: './login-default.component.html',
  styleUrls: ['./login-default.component.scss']
})
export class LoginDefaultComponent implements OnInit {
  formData: any;
  passwordHas: any;
  // SUPERSECRET: string = environment.SUPERSECRET;

  constructor(private http: HttpClient, private router: Router, private service: AuthService) { }

  ngOnInit(): void {
  }

  forgotPasswordData: { forgotPasswordBgImg: string; placeholderIcon: string }[] = [{
    forgotPasswordBgImg: 'assets/images/carouselbg.png',
    placeholderIcon: 'fa fa-lg fa-lock'
  }]
  sessionApiEndPoint = `https://stghufdmsapi.dhwaniris.com/web/api/session/create`
  sendEmail: any;
  formFields: { type: string; label: string; inputType: string; name: string; validations?: { name: string; validator: string; message: string }[]; placeholderIcon: string; showHide: string; placeholder: string }[] = [
    {
      type: "text",
      label: "username",
      inputType: "text",
      name: "username",
      validations: [
        {
          name: "required",
          validator: "required",
          message: "Username Required!"
        },
        // {
        //   name: "pattern",
        //   validator: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
        //   message: "Please fill valid email!"
        // }
      ],
      placeholderIcon: 'fas fa-user-alt',
      showHide: 'no',
      placeholder: 'Username'
    }, {
      type: "password",
      label: "password",
      inputType: "password",
      name: "name",
      validations: [
        {
          name: "required",
          validator: "required",
          message: "Password Required!"
        }
      ],
      placeholderIcon: 'fa fa-lg fa-lock',
      showHide: 'yes',
      placeholder: 'Password'
    }

  ];

  signUpFormFields: { type: string; label: string; inputType: string; name: string; validations?: { name: string; validator: string; message: string }[]; }[] = [
    {
      type: "input",
      label: "Username",
      inputType: "text",
      name: "username",
      validations: [
        {
          name: "required",
          validator: "required",
          message: "Username Required!"
        }
        // ,
        // {
        //   name: "pattern",
        //   validator: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
        //   message: "Please fill valid email!"
        // }
      ]
    }, {
      type: "password",
      label: "Password",
      inputType: "password",
      name: "password",
      validations: [
        {
          name: "required",
          validator: "required",
          message: "Password Required!"
        }
      ]
    }
    , {
      type: "number",
      label: "Mobile Number",
      inputType: "number",
      name: "number",
      validations: [
        {
          name: "required",
          validator: "required",
          message: "Number Required!"
        }
      ]
    }
  ];
  loginDetails: { backgroundImg: string; companyLogo: string; coprightText: string; companyText: string; title: string; forgotPassword: string; signUp: string; captchaText: string; } = {
    backgroundImg: 'assets/images/carouselbg.png',
    companyLogo: '',
    coprightText: '',
    companyText: '',
    title: 'Login As Facility',
    forgotPassword: 'yes',
    signUp: 'no',
    captchaText: 'no',
    // position: 'left', //login background image position left or right
    // manyata: 'yes'
  };

  signUpDetails: { backgroundImg: string; companyLogo: string; coprightText: string; companyText: string; title: string; position: string; forgotPassword: string; signUp: string } = {
    backgroundImg: 'https://thumbs.dreamstime.com/b/beautiful-rain-forest-ang-ka-nature-trail-doi-inthanon-national-park-thailand-36703721.jpg',
    companyLogo: 'https://thumbs.dreamstime.com/b/beautiful-rain-forest-ang-ka-nature-trail-doi-inthanon-national-park-thailand-36703721.jpg',
    coprightText: 'Powered by Dhwani Rural Information System pvt. ltd.',
    companyText: 'Hindustan Unilever Limited',
    title: 'Sign-Up',
    position: 'left', //login background image position left or right
    forgotPassword: 'yes',
    signUp: 'yes'
  };

  receiveCrossIcon(event: any) {
    // console.log(event);
    if (event) {
      this.router.navigate(['/dashboard']);
    }
  }

  receiveData(event: any) {
    // this.formData = event;
    let passwordHas = CryptoJS.HmacSHA256(event.password, environment.SUPERSECRET).toString();
    // this.encryptPassword();

    let keys = Object.keys(event);

    let payload = {}
    keys.map((key) => {
      console.log(key);

      if (key !== 'password') {
        payload[key] = event[key];
      }
    })

    payload = { ...payload, password: CryptoJS.HmacSHA256(event['password'], environment.SUPERSECRET).toString() }
    // payload['password'] == CryptoJS.HmacSHA256(event['password'], environment.SUPERSECRET).toString();
    console.log(payload);
    // console.log('receiveData formData', event, CryptoJS.HmacSHA256(event['password'], environment.SUPERSECRET).toString());

    // event['password'] = CryptoJS.HmacSHA256(event['password'], environment.SUPERSECRET).toString();

    this.service.login(payload).subscribe((res: any) => {
      console.log('login response', res);
      // delete this.formData.captchaText;
      sessionStorage.setItem("loginStatus", "true");
      sessionStorage.setItem("login email", event.username);
      sessionStorage.setItem("token", res.token);
      sessionStorage.setItem("facility name", res.data.facility_name);
      sessionStorage.setItem("userId", res.data.id);
      sessionStorage.setItem("created_at", res.data.created_at);
      sessionStorage.setItem("login contact number", res.data.mobile);

      if (res.data.role_id !== 1) {  // Not Admin
        sessionStorage.setItem("isProfileUpdated", res.data.isProfileUpdated);
        sessionStorage.setItem("isPasswordChange", res.data.isPasswordChange);
        // sessionStorage.setItem("profileStatus", res.data.isProfileUpdated && res.data.isPaymentComplete ? 'Onboarded' :  res.data.isProfileUpdated && res.data.isPaymentComplete == false ? 'Payment Pending' : res.data.isProfileUpdated == false ? 'Registration Pending' : '');
      }

      if (res.data.role_id == 1) {          // If Admin
        sessionStorage.setItem("adminLogin", "true");
        this.router.navigate(['/admin/dashboard']);
      } else if (res.data.role_id == 2) {   // If not Admin
        if (res?.data?.isPasswordChange == true) {
          if (res.success) {
            // Swal.fire({
            //   icon: 'success',
            //   title: 'Success',
            //   text: 'Logged in successfully!',
            // })

            if (res.data.isProfileUpdated) {
              this.router.navigate(['/welcome-login'])
            } else {
              this.router.navigate(['/login/detailed-register']);
            }
            // this.router.navigate(['/login/detailed-register']);

          }
        } else {
          this.router.navigate(['/login/reset-password']);
        }
      }
    },
      (err) => {

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: err.error.message,
        })
      })
  }

  // encryptPassword() {
  //   this.passwordHas = CryptoJS.HmacSHA256(this.formData.password, environment.SUPERSECRET).toString();
  // }

  // getOtp(event: any) {
  //   // console.log(event);

  // }

  // receiveCred(event: any) {
  //   // console.log(event);
  //   this.http.post<any>('https://reqres.in/api/posts', event).subscribe((data: any) => {
  //     // console.log(data);
  //     this.sendEmail = data
  //   })
  // }

  // receiveRegEmail(event: any) {
  //   // console.log(event);

  // }

  // receiveSignUpdata(event: any) {
  //   // console.log(event);

  // }

  // receiveFData(event: any) {
  //   // console.log(event)
  // }

}
